var map = {
	"./face_cry.svg": 117,
	"./face_nosmile.svg": 118,
	"./face_sad.svg": 119,
	"./face_smile.svg": 120,
	"./face_toxic.svg": 121,
	"./face_verysad.svg": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;